import React from 'react';
import Helmet from 'react-helmet';
import PageNotFound from './PageNotFound';
const createReactClass = require('create-react-class');
const Cms = createReactClass({
  getInitialState: function () {
    return {
      body: "<div></div>",
    }
  },
  componentWillMount() {
    this.props.getCmsBody(this.props.params.cms);

    const { hash } = window.location;
    if (hash !== '') {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) element.scrollIntoView();
      }, 1000);
    }
  },
  componentWillUnmount() {
    //this.props.resetCms();
  },
  componentWillReceiveProps(nextProps) {
    if (this.props.params.cms !== nextProps.params.cms) {
      this.props.getCmsBody(nextProps.params.cms);
    }
    const body = nextProps.cms.getCms && nextProps.cms.CmsContent ? (nextProps.location.search === "?draft" ? nextProps.cms.CmsContent.data.content.draft : nextProps.cms.CmsContent.data.content.body) : this.state.body;
    this.setState({ body: body, });
    let title = "ShippingCart";
    title = nextProps.cms.fetching ? title : (nextProps.cms.getCms && nextProps.cms.CmsContent ? nextProps.cms.CmsContent.data.name + " | " +title:"Page not found :(");
    document.title = title;
    
    // if (nextProps.auth.isAuthenticated !== this.props.auth.isAuthenticated){
    //   const email = nextProps.login.login.party.email ? nextProps.login.login.party.email : "";
    //   this.setState({email}, () => this.netcoreScript(this.state.email))
    // }
  },
  componentDidMount() {
    window.scrollTo(0, 0)
    
    // const w = window; 
    // <!-- NetCore Script -->
    // this.netcoreScript = (email) => {
    //   w.smartech('create','ADGMOT35CHFLVDHBJNIG50K969R5IJDR7QSKURD40EMEKF18IN70');
    //   w.smartech('register', '5cbfa9252c18508b714b90fa118de653');
    //   w.smartech('identify', email ? email : ""); // under '', please pass the EMAIL of web visitor. Else please do not pass any value
    //   w.smartech('dispatch',1,{});        
    // };
    // this.netcoreScript(this.state.email)
    // <!-- NetCore Script -->    
  },
  createMarkup(data) {
    return { __html: data, };
  },
  render() {
    return (
      <div>
        { this.props.cms.CmsContent && this.props.cms.CmsContent.data.description ?
          <Helmet
            meta={[
              { name: 'description', content: this.props.cms.CmsContent.data.description },
            ]} /> : null
        }
        {
          this.props.cms.fetching ?
            <div className="container page-container cms" dangerouslySetInnerHTML={this.createMarkup(this.state.body)} />
            :
            this.props.cms.getCms ?
              <div className="container page-container cms" dangerouslySetInnerHTML={this.createMarkup(this.state.body)} />
              :
              <PageNotFound {...this.props} />
        }
      </div>
    )
  },
})

export default Cms;



/** WEBPACK FOOTER **
 ** ./src/components/Cms.js
 **/